import guid from '@/lib/guid'
import {createGrid, Grid} from '@/models/grid'

function clean(obj) {
  for (var propName in obj) {
    if (obj[propName] === undefined) {
      delete obj[propName];
    }
  };
  return obj
}

export class Layout {
  constructor({
    id = null, name = null, pageId = null, styles = [], grids = [],
      colNum = 12, rowHeight = 20, isDraggable = true, isResizable = true,
      isMirrored = false, verticalCompact = true, margin = [10, 10],
      cssTransforms = true, responsive = false, breakpoint = 'desktop'
  } = {}) {

    if (!id) {
      console.log("creating layout id");
      this.id = guid.createId('layout');
    } else {
      this.id = id;
    }


    if (!name) {
      this.name = 'Layout ' + this.id;
    }

    //console.log("creating layout with breakpoint", breakpoint);

    this.pageId = pageId;
    this.styles = styles;
    if(grids && grids.length) {
      // console.log("loading grids", grids);
      this.loadGrids(grids);
    } else {
      this.grids = grids;
    }
    this.colNum = colNum;
    this.rowHeight = rowHeight;
    this.isDraggable = isDraggable;
    this.isResizable = isResizable;
    this.isMirrored = isMirrored;
    this.verticalCompact = verticalCompact;
    this.margin = margin;
    this.breakpoint =  breakpoint;
    this.cssTransforms = cssTransforms;
    this.responsive = responsive;

  }
  loadGrids(grids) {
      this.grids = [];
      for(let i = 0; i < grids.length; i++) {
        const grid = grids[i];

        if (grid instanceof Grid) {
          grid.layout = this;
          this.grids.push(grid);
        } else {
          let g = createGrid(clean(grid));

          g.layout = this;
          this.grids.push(g);
        }

      }
  }
  getApiInput(resetId) {
    let result = {
      id: this.id,
      breakpoint: this.breakpoint,
      pageId: this.pageId,
      styles: this.styles,
      colNum: this.colNum,
      rowHeight: this.rowHeight,
      isDraggable: this.isDraggable,
      isResizable: this.isResizable,
      isMirrored: this.isMirrored,
      verticalCompact: this.verticalCompact,
      margin: this.margin,
      verticalCompact: this.verticalCompact,
      responsive: this.responsive,
      grids: []
    }
    if(typeof this.id != "undefined") {
      result.id = this.id;
    }

    if(typeof resetId != "undefined" && resetId == true) {
      console.log("recreating layout id");
      result.id = guid.createId('layout');
    }
    

    Object.entries(this.grids).forEach(entry => {
      let key = entry[0];
      let item = entry[1];
      result.grids.push(item.getApiInput(resetId));
    });
    return result;
  }
}

export function createLayout(data) {
  return new Layout(data);
}
